import { useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Container, Card } from 'ui';
import { useSnack, useError } from 'hooks';
import { useTranslation } from 'react-i18next';
import { Header } from 'components';
import ExperienceSegmentForm from '../../../components/Forms/ExperienceSegmentForm';
import { useAsync } from 'react-async';
import { getSegment, updateSegment } from 'api/node/segments';
import { isEqual } from 'lodash';

const EditSegment = () => {
  const { segmentId } = useParams();
  const { state: selectedLocale } = useLocation();
  const { t } = useTranslation('experienceSegment');
  const navigate = useNavigate();
  const { notify } = useSnack();
  const { sendErrorSnack } = useError();

  const [currentLocale, setCurrentLocale] = useState(selectedLocale);

  const { data } = useAsync({
    promiseFn: getSegment,
    segmentId,
    locale: currentLocale?.value,
    watchFn: (props, prevProps) => {
      return !isEqual(props.locale, prevProps.locale);
    },
  });

  const handleUpdateSegment = async (values) => {
    try {
      await updateSegment({
        locale: currentLocale?.value,
        segmentId,
        payload: values,
      });

      navigate('/settings/experiences/segments', { state: currentLocale });
      notify(t('editSegmentSuccess'));
    } catch (err) {
      sendErrorSnack(err);
    }
  };

  return (
    <>
      <Header />

      <Container size="narrow">
        <Card>
          <ExperienceSegmentForm
            onSubmit={handleUpdateSegment}
            segment={data?.data}
            queryLocale={currentLocale}
            updateQueryLocale={setCurrentLocale}
          />
        </Card>
      </Container>
    </>
  );
};

export default EditSegment;
